import CONSTANTS from './constants.js'
import utils from './utils'
import axios from 'axios'
const instance = axios.create({
    timeout: 30000
})

/**
 * @method resetAjax ()ajax方法的封装
 * @param param.method 请求的方法
 * @param param.url 请求的地址
 * @param param.urlType 如何拼接地址 不存在用默认拼接; 1: host + url; 2: url
 * @param param.data 请求的数据
 * @param param.onSuccess 成功时需要的回调
 * @param param.onError 错误时需要的回调
 * @param param.sTipStr 成功时的提示
 * @param param.eTipStr 错误时的提示
 * @param param.isSNoTip   true说明成功的不需要弹提示，默认为false
 * @param param.isENoTip   true说明不需要错误的提示信息，默认为false
 * @param param.isNoLock true代表不需要锁屏
 * @param param.headers 对于特殊的请求头设置
 */

export default (that) => {
    return (param) => {
        let subKey = param.url.split("VERSION")[0]
        let apigw = 'evo-apigw/'
        // let apigw = ''
        let realVersion = localStorage[subKey.replace(/\//g, '')] ? localStorage[subKey.replace(/\//g, '')] : '1.0.0'
        let path = ""
        switch (param.urlType) {
            case 1:
                path = CONSTANTS.basePath + param.url
                break;
            case 2:
                path = param.url
                break;
            default:
                path = CONSTANTS.basePath + apigw + param.url.replace('VERSION', realVersion)
                break;
        }
        let localLanguage = localStorage.language || navigator.language || navigator.browserLanguage
        if (localLanguage.indexOf('en') >= 0) {
            localLanguage = 'en-US'
        }
        else if (localLanguage.indexOf('zh') >= 0) {
            localLanguage = 'zh-CN'
        }
        if (!localStorage.clientType) {
            localStorage.clientType = 1
        }
        instance.defaults.headers.common['user-client'] = localStorage.clientType
        instance.defaults.headers.common['Accept-Language'] = localLanguage
        if(localStorage.getItem('personCode')) {
            instance.defaults.headers.common['personCode'] = localStorage.getItem('personCode')
        }
        if(localStorage.getItem('ticket')) {
            instance.defaults.headers.common['ticket'] = localStorage.getItem('ticket')
        }
        // if (localStorage.accessToken) {
        //     instance.defaults.headers.common['Authorization'] = `bearer ${localStorage.getItem('accessToken')}`
        // }
        instance.defaults.headers.common['timeOffset'] = new Date().getTimezoneOffset() * 60 * 1000
        let headers = param.headers || {}
        let sendData = {
            method: param.method,
            url: path,
            data: param.data || {},
            params: param.data && param.data.params ? param.data.params : {},
            headers: { ...headers },
            timeout: param.timeout || 30000,
            cancelToken: param.cancelToken ? param.cancelToken : null//axios内置手动取消请求的属性
        }
        param.responseType ? sendData.responseType = param.responseType : ''
        const dealData = async (result) => {
            let res = param.isParseHtml ? result : utils.decodeObj(result)
            let codeArg = res.data.data ? (res.data.data.args ? res.data.data.args[0] : res.data.data.value ? res.data.data.value[0] : '') : ''
            localStorage.tError = ''
            if (res.data.code === '0' || res.data.code === 1000 || res.data.success === true) {
                param.onSuccess && param.onSuccess(res)
                if (param.isSNoTip) {
                    return
                }
                let msg = param.sTipStr ? param.sTipStr : that.$t('operaterSuccess')
                !param.hideTip && that.$toast.success(msg)
                //27001007代表当前token失效，需要去用refreshtoken请求新的token
            } else if (res.data.code === '27001007') {
                if (that.$route.path === '/login') {
                    return false
                }
                const refreshToken = localStorage.getItem('refreshToken')
                if (refreshToken !== 'undefined' && refreshToken) {
                    //获取新的token
                    let RefreshTokenState = await utils.SetRefreshToken(that)
                    if (!RefreshTokenState) {
                        return false
                    }
                    const accessToken = localStorage.accessToken
                    let param = {
                        method: 'post',
                        url: `/evo-apigw/evo-brm/${localStorage['evo-brm']}/user/keepalive`,
                        headers: { 'Authorization': `bearer ${accessToken}` },
                        data: {
                            clientType: 1,
                            magicId: localStorage.magicId,
                            timeout: 10000
                        }
                    }
                    await instance(param)
                    sendData.headers['Authorization'] = `bearer ${accessToken}`
                    const result = await instance(sendData)
                    dealData(result)
                    return
                }
                //如果没有获取refreshtoken则跳到登录页，所以上个if逻辑必须要有跳出动作
                // parent.location.hash = "#/login"
                if (!!window.ActiveXObject || "ActiveXObject" in window) {
                    window.location.reload()
                }
            } else {
                param.onError && param.onError(res)
                if (param.isENoTip || param.hideTip) {
                    return
                }
                let defaultErrMsg = param.eTipStr ? param.eTipStr : 'ajaxDisconnect'
                let errMsg = res.data.code ? `error${res.data.code}` : defaultErrMsg
                let msg = param.eTipStr ? param.eTipStr : errMsg
                that.$toast.fail(that.$t(msg, [codeArg]))
            }
        }
        instance(sendData).then(result => dealData(result)).catch((error) => {
            param.onError && param.onError(error)
            let cTime = new Date().getTime()
            let errorStatus = error.response && error.response.status
            if ((cTime - localStorage.errorTime < 200) && !param.isENoTip) {
                localStorage.tError = 'serverError'
                return
            }
            localStorage.errorTime = cTime
            let msg = param.eTipStr ? param.eTipStr : 'ajaxDisconnect'
            let errMsg = errorStatus ? `error${errorStatus}` : msg
            if (param.isENoTip || param.hideTip) {
                return
            }
            that.$toast.fail(that.$t ? that.$t(errMsg) : errMsg)
        })
    }
}
